export default "__VITE_ASSET__6DD5mF3L__"